/*
 *Any general permission will have this format
 *<who>_<majorfunction>_<minorfuction>:<access rw eg: visit>
 *
 * example:-
 * The Run functions permission
 *
 * advisor_runfn_plaid_repull_asset:visit
 *
 */


// Advisor Dashboard General
export const ADVISOR_DASHBOARD_REPORT_PERMISSIONS = 'advisor_dashboard_reports:visit';
export const ADVISOR_DASHBOARD_HELP_CENTER_PERMISSIONS = 'advisor_dashboard_help_center:visit';
export const ADVISOR_DASHBOARD_HELP_CENTER_VIDEOS_VIEW = 'advisor_dashboard_help_center_videos:visit';
export const ADVISOR_DASHBOARD_HELP_CENTER_SHAREPOINTS_VIEW = 'advisor_dashboard_help_center_sharepoint:visit';
export const ADVISOR_DASHBOARD_HELP_CENTER_VIDEOS_WRITE = 'advisor_dashboard_help_center_videos:write';
export const ADVISOR_DASHBOARD_HELP_CENTER_SHAREPOINTS_WRITE = 'advisor_dashboard_help_center_sharepoint:write';


export const ADVISOR_ADMINCENTER_MORTGAGE_RATES_PERMISSIONS = 'advisor_admincenter_mortgage_rates_menu:visit';

export const ADVISOR_TASKS_PERMISSIONS = 'advisor_dashboard_all_tasks_menu:visit';
export const ADVISOR_TABS_NEW_TASK_DISABLE_PERMISSIONS = 'advisor_dashboard_alltasks_new:mask';
export const ADVISOR_MANAGE_LOAN_VOL_DISABLE_DELETE = 'advisor_manage_loan_application_vol_delete:mask';



// Advisor Dashboard Pipeline
export const SELECT_STATUS_TO_FILTER_PERMISSION =
  'advisor_dashboard_pipeline_stage:read';
export const SELECT_PRIORITY_PERMISSION = 'advisor_dashboard_pipeline_priority:write';
export const ADVISOR_DASHBOARD_REASSIGN_VISIT = 'advisor_dashboard_pipeline_reassign:visit';
export const ADVISOR_DASHBOARD_REASSIGN_DISABLE = 'advisor_dashboard_reassign:disable';
export const ADVISOR_DASHBOARD_MANAGELOAN_COL_PRIORITY =
  'advisor_dashboard_pipeline_priority:visit';
export const ADVISOR_DASHBOARD_MANAGELOAN_COL_PRODUCT =
  'advisor_dashboard_pipeline_product:visit';
export const ADVISOR_DASHBOARD_MANAGELOAN_COLLATERAL_TYPE =
  'advisor_dashboard_pipeline_collateral_type:visit';
export const ADVISOR_DASHBOARD_FILTER_PRODUCT_TYPE =
  'advisor_dashboard_filter_producttype:visit';

export const ADVISOR_APPLICATIONS_PERMISSIONS = 'advisor_dashboard_pipeline_myapplications:visit';
export const ADVISOR_APPLICANT_CAN_DELETE_APPLICATION = "advisor_dashboard_delete_application:enable"
export const REASSIGN_WITHOUT_UPDATE_ADVISOR =
  'advisor_dashboard_continue_reassign_as_parent:visit';
export const REASSIGN_ADVISOR_MORTGAGE =
  'advisor_dashboard_continue_reassign_as_mortgage:visit';
export const ADVISOR_DASHBOARD_PRODUCT_TYPE_VISIT = 'advisor_dashboard_pipeline_product:read';
export const ADVISOR_PIPELINE_APPLICATION_NUMBER_ENABLE = "advisor_dashboard_pipeline_application_number:visit"


// Advisor Dashboard Launcher
export const ADVISOR_TABS_NEW_APPLICATION_LAUNCHER_PERMISSIONS = 'advisor_dashboard_newapp_launcher:visit';
export const ADVISOR_DASHBOARD_NEW_APPLICATION_GETSTART_PERMISSIONS = 'advisor_dashboard_start_newapp_to_getstarted:visit';
export const ADVISOR_DASHBOARD_NEW_APPLICATION_INBRANCH_LAUNCHER = 'advisor_dashboard_newapp_launcher_inbranch_option:visit';

export const ADVISOR_TABS_ADD_NEW_APPLICATION_PERMISSIONS =
  'advisor_dashboard_invite_applicant_launcher:visit';
export const IMPORT_MISMO_ADVISOR_VISIT_PERMISSION =
  'advisor_dashboard_launcher_import_mismo:visit';
export const IMPORT_APPLICATION_LO_VISIT_PERMISSION =
  'advisor_dashboard_launcher_import_new_application:visit';
export const IMPORT_APPLICATION_ENABLE_WORKOUT =
  'advisor_dashboard_import_application_with_workout:visit';
export const ADVISOR_LAUNCH_NEW_APPLICATION_WITH_PHONE_PERMISSION =
  'advisor_dashboard_new_application_withphone:visit';
export const DISABLE_EDIT_ACCESS_LOAN_STAGES_PERMISSION =
  'advisor_dashboard_loanstage_disable:visit';
export const DISABLE_EDIT_ACCESS_LOAN_STAGES_ON_DASHBOARD_PERMISSION =
  'advisor_dashboard_loanstage_change_disable:write'
export const DISABLE_LOAN_STAGE_BASED_ON_EXCEEDING_LIMIT =
  'advisor_dashboard_loanstage_disable_on_exceeding_lending_limit:visit';

export const ADVISOR_APPLICATION_ISO_DROPDOWN_VISIT =
  'advisor_dashboard_newapplication_withiso:visit';
export const ADVISOR_PIPELINE_BASED_ON_LIMIT ='advisor_dashboard_pipeline_disable_lending_limit_filter:visit';
export const ADVISOR_PIPELINE_LENDER_GROUPS_ON_QUEUES ='advisor_dashboard_pipeline_lender_group_apps_queues:visit';

// Advisor Dashboard Servicing

// Advisor One Loan Application
export const ADVISOR_ONELOAD_OVERVIEW_PERMISSION = 'advisor_oneloan_overview_menu:visit';
export const ADVISOR_ONELOAN_OVERVIEW_PERMISSION = 'advisor_oneloan_overview:visit';
export const DOCUMENT_PERMISSION = 'advisor_oneloan_document_menu:visit';
// New Application

// Import Application

// Invite Application

// All Servicing

// Invite Application

// All Approvals
export const APPROVED_DECLINE_ACTION_PERMISSION = 'approve_decline:visit';
export const ALL_APPROVE_ACTION_PERMISSION = 'advisor_dashboard_approvals:write';
export const ADVISOR_APPROVAL_ACTIVITY_PERMISSIONS =
  'advisor_dashboard_approvals:visit';
export const APPROVE_ALL_PERMISSION = 'advisor_approvals_bulk_approve:visit';

// ADVISOR ONELOAN

// General
export const ADVISOR_ONELOAN_DOCUMENT_CAN_DELETE_PERMISSION = 'advisor_oneloan_document_delete_actions:enable';
export const ADVISOR_ONELOAN_DOCUMENT_DOWNLOAD_PERMISSION = 'advisor_oneloan_document_download_actions:mask';

export const ADVISOR_DOCUMENT_LOAN_PACKAGE_ACTIONS_PERMISSION = 'advisor_oneloan_download_loanpackage:visit';
export const ADVISOR_DOCUMENT_UPLOAD_ACTIONS_DISABLE_PERMISSION = 'advisor_oneloan_document_upload:mask';
export const ADVISOR_ONELOAN_NOTES_PERMISSION = 'advisor_oneloan_notes_menu:visit';
export const ADVISOR_ONELOAN_NOTES_ADD_BUTTON_DISABLE_PERMISSION = 'advisor_oneloan_notes_add_button:mask';
export const ADIVSOR_ONELOAN_ACTIVITY_PERMISSION = 'advisor_oneloan_activities_menu:visit';
export const ADIVSOR_ONELOAN_TASK_PERMISSION = 'advisor_oneloan_tasks_menu:visit';
export const ADVISOR_ONELOAN_EDIT_TASK_MASK_PERMISSION = 'advisor_oneloan_edittask:mask';
export const ADIVSOR_ONELOAN_CHAT_PERMISSION = 'advisor_oneloan_chat_menu:visit';

export const LOAN_PRODUCT_ADVISOR_PERMISSION = 'advisor_oneloan_freddiemac_menu:visit';
export const FINANCIAL_REPORTS_PERMISSION = 'advisor_oneloan_flashspread_menu:visit';
export const APPLICATION_STAGES_SELECTOR = 'advisor_oneloan_stages_selector:write';
export const MASK_ASSIGNEE_STAGES_FOR_HC = 'advisor_dashboard_pipeline_assignee:visit';


export const ADVISOR_RECENT_TAB_VISITS =
  'advisor_oneloan_recentvisits:visit';

export const ADVISOR_APPLICANT_DETAILS_HIGHCREST_VISIT =
  'advisor_oneloan_highcrest_submission:visit';
export const ADVISOR_ONELOAN_MEMO_VISIT =
  'advisor_oneloan_memo:visit';

export const ADVISOR_APPLICANT_INFORMATION_FUNDERS_VISIT =
  'advisor_oneloan_applicant_information_funders:visit';
export const ADVISOR_APPLICANT_INFORMATION_DATA_MERCH_VISIT =
  'advisor_oneloan_applicant_information_data_merch:visit';
export const ADVISOR_ONELOAN_CREDIT_REPORT_VISIT =
  'advisor_oneloan_credit_report:visit';
export const ADVISOR_BUSINESS_APPLICATION_HISTORY_VISIT =
  'advisor_business_application_history:visit';


export const ADVISOR_APPLICANT_INFORMATION_NEW_OWNERS_VISIT =
  'advisor_oneloan_applicant_information_new_owners:visit';

export const ADVISOR_ONELOAN_HISTORY_PERMISSIONS = 'advisor_oneloan_history:visit';
export const ADVISOR_ONELOAN_CHEXSYSTEMS_SUMMARY = 'advisor_oneloan_chexsystems_summary:visit';
export const ADVISOR_APPLICATION_INFO_PERMISSIONS =
  'advisor_oneloan_application_information:visit';
export const ADVISOR_CREDIT_REPORT_DEBUG =
  'advisor_oneloan_creditpulldebug:read';

export const ADVISOR_APPLICATION_1UP_ASSIGN_LENDING_LIMIT = 'advisor_oneloan_1up_assign_lending_limit:visit';


// Application Not Mortgage
export const UW_REQUEST_PERMISSION = 'advisor_oneloan_uwrequest:visit';
export const APPLICATION_EDITABLE_READ_PERMISSION = 'advisor_oneloan_edit:write';
export const UW_DECISION_PERMISSION = 'advisor_oneloan_uwdecision_menu:visit';

export const ADVISOR_TABS_NEW_TASK_PERMISSIONS = 'advisor_oneloan_new_tasks:visit';
export const MY_TASKS_TAB_PERMISSION_FOR_ALL = 'advisor_dashboard_alltasks_mytasks:visit';
export const ASSIGNED_TASKS_TAB_PERMISSION_FOR_NOT_ISO =
  'advisor_dashboard_alltasks_assigned:visit';
export const ADVISOR_TASK_MARK_AS_COMPLETE_ACTION_VISIT =
  'advisor_task_action_mark_as_complete:visit';
export const ADVISOR_TASK_REMOVE_ACTION_VISIT =
  'advisor_task_action_remove:visit';
// URLA
export const ADVISOR_ONE_LOAN_URLA_UPDATE = 'advisor_oneloan_urla:write';
export const ADVISOR_OVERRIDE_CODES_VISIT = 'advisor_oneloan_override_codes:visit';


// LOS (Encompass)
export const ADVISOR_PUSH_ENCOMPASS_VISIT =
  'advisor_runfn_push_encompass:visit';
export const ADVISOR_PULL_ENCOMPASS_VISIT =
  'advisor_runfn_pull_encompass:visit';


// LOS (LaserPro)
export const ADVISOR_LASER_PRO_VISIT = 'advisor_runfn_push_laserpro:visit';

// Ocrolus

export const ADVISOR_OCROLUS_VISIT = 'advisor_runfn_ocrolus:visit';
// Copper
export const ADVISOR_APPLICANT_INFORMATION_COPPER_LEAD_VISIT =
  'advisor_applicant_information_copper_lead:visit';
// Car Fax Run
export const ADVISOR_CARFAX_REPORT_PULL = 'advisor_runfn_carfax_report_pull:visit';
// CoreLogic Flood Run
export const ADVISOR_PUSH_CORELOGIC_FLOOD_REPORT = 'advisor_runfn_push_corelogic_flood_report:visit';

// Deliver EVP Report Run function
export const ADVISOR_DELIVER_EVP_REPORT_VISIT = 'advisor_runfn_deliver_evp_report:visit';

// Credit Providers


// Credit Providers (Experian)
export const ADVISOR_EXPERIAN_PERMISSION = 'advisor_runfn_pullcredit_experian:visit';

// Credit Providers (Transunion)
export const ADVISOR_TRANSUNION_PERMISSIONS = 'advisor_runfn_pullcredit_transunioin:visit';
export const ADVISOR_TRANSUNION_MORTGAGE_PERMISSIONS =
  'advisor_runfn_transunion_mortgage:visit';

export const ADVISOR_RUNFN_SHARPER_LENDING_CREDIT_PULL =
  'advisor_runfn_sharper_lending_credit_pull:visit';

export const ADVISOR_TRANSUNION_SOFT_PULL_PERMISSIONS =
  'advisor_runfn_transunion_soft_pull:visit';

export const ADVISOR_TRANSUNION_HARD_PULL_PERMISSIONS =
  'advisor_runfn_transunion_hard_pull:visit';
// Credit Providers (KCB)
export const ADVISOR_KCB_CREDIT_PULL_VISIT =
  'advisor_runfn_pullcredit_kcb:visit';

// Credit Providers (Meridian)
export const ADVISOR_MERIDIAN_CREDIT_PULL_VISIT =
  'advisor_runfn_pullcredit_meridianlink:visit';

// Credit Providers (Hartsoftware)
export const ADVISOR_HARTSOFTWARE_CREDIT_REPORT_VISIT =
  'advisor_runfn_pullcredit_hartsoftware:visit';


export const ADVISOR_RUN_FN_EQUIFAX_SOFT_VISIT = 'advisor_runfn_equifax_soft:visit';
export const ADVISOR_RUN_FN_EQUIFAX_HARD_VISIT = 'advisor_runfn_equifax_hard:visit';



// Run Functions (General)


export const ADVISOR_INVITE_CO_APPLICANT_VISIT =
  'advisor_runfn_invite_co_applicant:visit';

// Run Functions (Mortgage)
export const ADVISOR_TENOTHREE_VISIT = 'advisor_runfn_1003:visit';
export const ADVISOR_PUSH_TO_MORTGAGEBOT_VISIT =
  'advisor_runfn_push_mortgagebot:visit';
export const ADVISOR_PUSH_TO_DECISION_PRO_VISIT =
  'advisor_runfn_decision_pro:visit';
export const ADVISOR_PUSH_TO_DCI_VISIT =
  'advisor_runfn_dci:visit';
export const ADVISOR_PULL_FROM_MORTGAGEBOT_VISIT =
  'advisor_runfn_pull_mortgagebot:visit';
export const ADVISOR_APPLICATION_RUNFN_MULTIPLE_VISIT = 'advisor_runfn_application_multipdf:visit';
export const ADVISOR_RUN_DROPDOWN_VISIT = 'advisor_runfn_mortgage_applicant:visit';
export const ADVISOR_34XML_EXPORT_VISIT = 'advisor_runfn_34_exportxml:visit';
export const ADVISOR_TAX_STATUS_VERIFY_VISIT = 'advisor_runfn_tax_status_verify:visit';
export const ADVISOR_RUN_ASSET_REFRESH_VISIT = 'advisor_runfn_plaid_repull_asset:visit';
export const ADVISOR_RUN_INCOME_REFRESH_VISIT = 'advisor_runfn_plaid_repull_income:visit';
export const ADVISOR_RUN_HOUSING_COUNSELOR_REPORT = 'advisor_runfn_housing_counselor_report:visit';
export const ADVISOR_SEND_TO_ESIGN_VISIT = 'advisor_runfn_send_to_esign:visit';
export const ADVISOR_SEND_TO_ESIGN_VIA_PROSIGN_VISIT = 'advisor_runfn_send_to_esign_via_prosign:visit';
export const ADVISOR_SEND_PUSH_TO_CORE_VISIT = 'advisor_runfn_send_push_to_core:visit';


// Run Functions  (Not Mortgage)
export const ADVISOR_SEND_ESIGN_VISIT = 'advisor_runfn_create_send_esign:visit';
export const ADVISOR_VIEW_CONTRACT_VISIT = 'advisor_runfn_view_contract:visit';
export const ADVISOR_VIEW_CONTRACT_PDF_VISIT =
  'advisor_runfn_view_contract_pdf:visit';
export const ADVISOR_CREATE_CONTRACT_VISIT =
  'advisor_runfn_create_contract:visit';
export const ADVISOR_DTI_SHEET_VISIT = 'advisor_runfn_dti_sheet:visit';
export const ADVISOR_UW_DECISION_PERMISSIONS =
  'advisor_runfn_uw_decision:visit';
export const ADVISOR_BUSINESS_FINANCIALS_VISIT =
  'advisor_runfn_business_financials:visit';
export const ADVISOR_REPULL_BUSINESS_FINANCIALS_VISIT =
  'advisor_runfn_repull_business_financials:visit';
export const ADVISOR_RUN_AVM_REPORT =
  'advisor_runfn_avm_report:visit';
export const ADVISOR_RUN_ACH =
  'advisor_runfn_ach:visit';
export const ADVISOR_KYB_MIDDESK_VISIT =
  'advisor_runfn_kyb_middesk:visit';
export const ADVISOR_UW_EXCEL_PERMISSIONS = 'advisor_runfn_uwexcel:visit';

export const ADVISOR_APPLICATION_CONSUMERLOAN_VISIT =
  'advisor_runfn_application_consumerloan:visit';
export const ADVISOR_APPLICATION_CONSUMER_ANALYSIS_VISIT =
  'advisor_runfn_consumer_analysis_report:visit';
export const ADVISOR_DWOLLA_DEPOSITACCT_TRANFER_VISIT =
  'advisor_runfn_dwolla_depositacct_transfer:visit';
export const ADVISOR_DCI_TO_DWOLLA_REGISTER_VISIT =
  'advisor_runfn_dci_to_dwolla_register:visit';
export const ADVISOR_CSI_NUPOINT_VISIT = 'advisor_runfn_csi_nupoint:visit';

// Borrower Dashboard
export const APPLICANT_OVERVIEW = 'applicant_dashboard_overview_menu:visit';
export const APPLICANT_TASK = 'applicant_dashboard_tasks_menu:visit';
export const APPLICANT_DOCUMENTS = 'applicant_dashboard_documents_menu:visit';
export const APPLICANT_LOCKRATE = 'applicant_dashboard_lockrate_menu:visit';
export const APPLICANT_E_DISCLOSURE = 'applicant_dashboard_edisclosure_menu:visit';
export const APPLICANT_DASHBOARD = 'applicant_dashboard_calculator_menu:visit';
export const APPLICANT_OVERVIEW_WITHDRAW_APPLICATION =
  'applicant_dashboard_withdraw:write';
export const APPLICANT_OVERVIEW_SEND_INVITE =
  'applicant_overview_send_invite:visit';
export const APPLICANT_OVERVIEW_MARKETPLACE_LINK_VIEW = 'applicant_overview_marketplace_link:visit';
export const ONELOAN_ADVISOR_EDIT_SUBMIT_APPLICATION =
  'advisor_oneloan_others_submit_application:visit';
export const ENABLE_RELATED_TO_FOR_TASK_PERMISSION =
  'advisor_tasks_col_related_to:visit';
export const APPLICANT_START_NEW_APPLICATION_VISIT = 'applicant_start_new_application:visit';
export const APPLICANT_CHAT_VISIT = 'applicant_dashboard_chat_menu:visit';

// Admin Center
export const MANAGE_ACCESS_PERMISSIONS = 'advisor_admincenter_manage_access:visit';

export const ADVISOR_ADMINCENTER_GENERAL_MORTGAGE_REPORT =
  'advisor_admincenter_general_mortgage_report:visit';
export const ADVISOR_ADMINCENTER_MARKETING_REPORT =
  'advisor_admincenter_marketing_report:visit';
export const ADVISOR_ADMINCENTER_PRODUCTION_STATISTICS_REPORT =
  'advisor_admincenter_production_statistics_report:visit';
export const ADVISOR_ADMINCENTER_UW_REPORT =
  'advisor_admincenter_uw_report:visit';
export const ADVISOR_ADMINCENTER_OFFERS_REPORT =
  'advisor_admincenter_offers_report:visit';
export const ADVISOR_ADMINCENTER_MANAGEUSER_ADDISO_VISIT = 'advisor_admincenter_manageuser_addiso:visit';
export const ADVISOR_ADMINCENTER_DOCUMENT_ACCESS = 'advisor_admincenter_document_access:visit';

export const ADVISOR_ADMINCENTER_LENDING_LIMINT_VISIT = 'advisor_admincenter_lending_limit_access:visit';

// Notifications
export const NOTIFICATIONS_PERMISSION = 'notifications:visit';
export const ADVISOR_NOTIFICATIONS_PERMISSIONS = 'advisor_dashboard_notifications_menu:visit';

// Directory
export const ADVISOR_RUN_FUNCTION_PERMISSION = 'advisor_oneloan_run_functions:mask';
export const ADVISOR_ADMINCENTER_USERS_PERMISSION = 'advisor_admincenter_users:visit';
export const ADVISOR_ADMINCENTER_MENU_PERMISSION = 'advisor_admincenter_menu:visit';
export const ADMIN_MANAGE_DIRECTORY_PERMISSION = 'advisor_admincenter_manage_directory:visit';
export const ADVISOR_ADMINCENTER_USERS_MANAGE_PERMISSION = 'advisor_admincenter_users:write'
// Reports
export const ADVISOR_DECLINED_REPORT =
  'advisor_declined_reports:visit';
export const ADVISOR_ONBOARD_SERVICING_REPORT =
  'advisor_onboard_servicing_report:visit';
export const ADVISOR_YTD_BROKER_SUBMISSIONS_REPORT =
  'advisor_ytd_broker_submissions_report:visit';
export const ADVISOR_ADMINCENTER_USER_ACTIVITY_REPORT =
  'advisor_admincenter_user_activity_report:visit';
export const ADVISOR_ADMINCENTER_GENERAL_REPORT_CARD =
  'advisor_admincenter_general_card_report:visit';

export const ADVISOR_ADMINCENTER_GENERAL_REPORT_HELOC =
  'advisor_admincenter_general_heloc_report:visit';

export const ADVISOR_GENERAL_FULL_REPORT =
  'advisor_general_full_report:visit';

export const ADVISOR_DENIAL_LOG_REPORT =
  'advisor_denial_log_report:visit';

export const ADVISOR_LOAN_QUARTERLY_DENIALS_REPORT =
  'advisor_loan_owl_quarterly_denials_report:visit';

export const ADVISOR_MLA_COVERED_BORROWER_REPORT =
  'advisor_mla_covered_borrower_report:visit';


export const ADVISOR_INTERNAL_USERS_REPORT ='advisor_internal_users_report:visit';
export const ADVISOR_APP_STATUS_CHANGED_REPORT ='advisor_application_status_changed_report:visit';


// Report Custom

// Bank Accounts
export const BANK_ACCOUNT_PERMISSION = 'advisor_oneloan_back_accounts:visit';
export const ADVISOR_ADMINCENTER_BANK_ACCOUNTS_PERMISSIONS = 'advisor_admincenter_bank_accounts:visit';

// Payment Service (BC)
export const PAYMENT_SCHEDULE_PERMISSION = 'advisor_oneloan_payment_schedule:visit';
export const PAYMENT_ACTIVITIES_PERMISSION = 'advisor_oneloan_payment_activities:visit';
export const PAYMENT_SERVICING_BUTTON_ACTION_VISIT =
  'advisor_oneloan_payment_servicing:visit';
export const PAYMENT_SERVICING_BUTTON_ACTION_WRITE =
  'advisor_oneloan_payment_servicing:write';
export const PAYMENT_APPROVE_ACTION_PERMISSION = 'advisor_oneloan_payment_approve:write';
export const ADVISOR_ALL_PAYMENT_ACTIVITY_PERMISSIONS =
  'advisor_oneloan_all_payment_activity:visit';
export const FUND_PERMISSION = 'advisor_oneloan_fund:visit';
export const ADVISOR_PAYMENT_VIEW_PERMISSION = 'advisor_oneloan_payment_schedules:visit';
export const ADVISOR_ADMINCENTER_PAYMENT_HOLD_REPORT =
  'advisor_admincenter_payment_hold_report:visit';
export const ADVISOR_ADMINCENTER_PAYMENT_DELINQUENT_REPORT =
  'advisor_admincenter_payment_delinquent_report:visit';


// Developer Setting Permissions

export const ADVISOR_ADMINCENTER_GLOBAL_SETTINGS_MENU =
  'advisor_admincenter_global_settings:visit';

export const ADVISOR_ADMINCENTER_VARMAPS_VIEW =
  'advisor_admincenter_dev_settings_varmaps:visit';

export const ADVISOR_ADMINCENTER_VARMAPS_WRITE =
  'advisor_admincenter_dev_settings_varmaps:write';

// Branch Permissions
export const ADVISOR_ADMINCENTER_BRANCH_MENU = "advisor_admincenter_branch_menu:visit";
export const ADVISOR_ADMINCENTER_BRANCH_VIEW = "advisor_admincenter_branch_list:visit";
export const ADVISOR_ADMINCENTER_BRANCH_WRITE = "advisor_admincenter_branch_list:write";
export const ADVISOR_PIPELINE_APPLICATIONS_BY_BRANCH =
  'advisor_dashboard_pipeline_application_by_branch:visit';
export const ADVISOR_PIPELINE_APPLICATIONS_BRANCH_GROUPING =
  'advisor_dashboard_pipeline_application_branch_grouping:visit';

export const ADVISOR_ADMINCENTER_SITE_BRANDING = "advisor_admincenter_site_branding_theme:write";

// Teams
export const ADVISOR_DASHBOARD_MY_TEAMS_VIEW = "advisor_dashboard_my_team_list:visit";
export const ADVISOR_DASHBOARD_MY_TEAMS_WRITE = "advisor_dashboard_my_team_list:write";
export const ADVISOR_ADMINCENTER_ALL_TEAMS_VIEW = "advisor_admincenter_all_teams:visit";
export const ADVISOR_ADMINCENTER_ALL_TEAMS_WRITE = "advisor_admincenter_all_teams:write";
export const ADVISOR_PIPELINE_APPLICATIONS_BY_TEAMS = "advisor_dashboard_pipeline_applications_by_team:visit";


// ==============================================================================
// Internal Loan Permission
// ==============================================================================

export const APPLICANT_ACCESS_ON_BEHALF_CO_APPLICANT_WRITE = 'applicant_access_on_behalf_co_applicant:write';
export const APPLICANT_ACCESS_ON_BEHALF_CO_APPLICANT_READ = 'applicant_access_on_behalf_co_applicant:read';

//global Advisor and Applicant
export const USER_LOGIN_TIMEOUT_MANAGE_READ = "user_login_timeout_manage:read";


//loan stage permissions
export const ADVISOR_PROPOSED_INTEREST_RATE_ABOVE_ONE_PERCENT = "advisor_proposed_interest_rate_above_one_percent:visit";
export const ADVISOR_LOAN_TERMS_EXCEEDED_12_MONTHS_OF_POLICY = "advisor_loan_terms_exceeded_12_months_of_policy_term:visit";
export const ADVISOR_LOAN_TERMS_UNDER_12_MONTHS_OF_POLICY = "advisor_loan_terms_under_12_months_of_policy_term:visit";

export const ADVISOR_LENDING_LIMIT_EXCEEDS = "advisor_lending_limit_exceeds:visit";
export const RATE_APPROVER_THRESHOLD_LIMIT = 0.10;


/**
 * ===================================================================
 * Constants
 * ===================================================================
*/
export const ADVISOR_LOAN_STAGE_COLOR_MAPPING ='advisor_loan_stage_color_mapping';


/**
 * ===================================================================
 * URLA fields permissions
 * ===================================================================
*/

export const ADVISOR_ONELOAN_RATE_APPROVAL = "advisor_oneloan_rate_override_approval:write";
export const ADVISOR_ONELOAN_CREDIT_APPROVAL = "advisor_oneloan_credit_limit_override_approval:write";
export const ADVISOR_ONELOAN_RATE_APPROVERS = "advisor_oneloan_rate_override_approvers:visit";
export const ADVISOR_ONELOAN_CREDIT_APPROVERS = "advisor_oneloan_credit_approvers:visit";
export const ADVISOR_ONELOAN_REQUEST_APPROVAL_APPROVERS = "advisor_oneloan_request_approval_approvers:visit";
export const ADVISOR_ONELOAN_FLOOD_REVIEW = "advisor_oneloan_flood_review:write";
export const ADVISOR_ONELOAN_TASK_AUTHORIZATION_COMPLETE = "advisor_oneloan_task_authorization_complete:write";
export const ADVISOR_ONELOAN_LOCK_OVERRIDE = "advisor_oneloan_lock_override_force_unlock:write";
export const ADVISOR_ONELOAN_APPLICATION_PROCESSORS = "advisor_oneloan_assign_application_processors:visit";
